<div class="panel-shell">
  <header class="panel-header">
    <div class="panel-title text-bold">
      {{ "ORDERS.EDIT_MATERIAL" | translate }}
    </div>
    <button
      mat-icon-button
      type="button"
      class="panel-close-btn"
      (click)="close()"
      aria-label="Close panel"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="panel-body">
  <div *ngIf="material" [formGroup]="form">
    <div class="flex-row-space-between-start fxLayoutGap-20">
      <div class="flex-column-space-between-stretch fxFlex-33p">
        <!-- INTERNAL_NAME_FR -->
        <mat-form-field class="item-width">
          <mat-label>{{ "ORDERS.INTERNAL_NAME_FR" | translate }}</mat-label>
          <input
            matInput
            class="fxFlex-100p"
            formControlName="name_internal_fr_CA"
            type="text"
            [(ngModel)]="material.name_internal_local.name_internal_fr_CA"
            required
          />
          <mat-error *ngIf="form.controls.name_internal_fr_CA.invalid">{{
            "GENERIC.INPUT_LENGTH_INVALID" | translate
          }}</mat-error>
        </mat-form-field>

        <!-- INTERNAL_NAME_EN -->
        <mat-form-field class="item-width">
          <mat-label>{{ "ORDERS.INTERNAL_NAME_EN" | translate }}</mat-label>
          <input
            matInput
            class="fxFlex-100p"
            formControlName="name_internal_en_CA"
            type="text"
            [(ngModel)]="material.name_internal_local.name_internal_en_CA"
            required
          />
          <mat-error *ngIf="form.controls.name_internal_en_CA.invalid">{{
            "GENERIC.INPUT_LENGTH_INVALID" | translate
          }}</mat-error>
        </mat-form-field>

        <!-- EXTERNAL_NAME_FR -->
        <mat-form-field class="item-width">
          <mat-label>{{ "ORDERS.EXTERNAL_NAME_FR" | translate }}</mat-label>
          <input
            matInput
            class="fxFlex-100p"
            formControlName="name_fr_CA"
            type="text"
            [(ngModel)]="material.name_local.name_fr_CA"
            required
          />
          <mat-error *ngIf="form.controls.name_fr_CA.invalid">{{
            "GENERIC.INPUT_LENGTH_INVALID" | translate
          }}</mat-error>
        </mat-form-field>

        <mat-form-field class="item-width">
          <mat-label>{{ "ORDERS.EXTERNAL_NAME_EN" | translate }}</mat-label>
          <input
            matInput
            class="fxFlex-100p"
            formControlName="name"
            type="text"
            [(ngModel)]="material.name_local.name_en_CA"
            required
          />
          <mat-error *ngIf="form.controls.name.invalid">{{
            "GENERIC.INPUT_LENGTH_INVALID" | translate
          }}</mat-error>
        </mat-form-field>

        <mat-form-field class="item-width">
          <mat-label>{{ "GENERIC.PRICE" | translate }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="unit_price"
            pattern="^[+-]?[0-9]+([.,][0-9]{1,2})?"
            [(ngModel)]="material.unit_price"
          />
          <mat-error *ngIf="form.controls.unit_price.invalid"
            >{{ "GENERIC.INPUT_NUMBER" | translate }}
            {{
              "GENERIC.INPUT_NUMBER_POSTFIX_2_DECIMAL" | translate
            }}</mat-error
          >
        </mat-form-field>

        <mat-form-field class="item-width">
          <mat-label>{{ "GENERIC.QUANTITY" | translate }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="quantity"
            pattern="^[+-]?[0-9]+([.,][0-9]{1,2})?"
            [(ngModel)]="material.qty"
          />
          <mat-error *ngIf="form.controls.quantity.invalid"
            >{{ "GENERIC.INPUT_NUMBER_ABOVE_ZERO" | translate }}
            {{
              "GENERIC.INPUT_NUMBER_POSTFIX_2_DECIMAL" | translate
            }}</mat-error
          >
        </mat-form-field>

        <!-- material category -->
        <div class="item-width">
          <app-gt2-select
            [label]="'GENERIC.MATERIAL_CATEGORY' | translate"
            [noResultsLabel]="translate.instant('GENERIC.NO_RESULTS')"
            [nullableUseNone]="false"
            [placeHolder]="'GENERIC.MATERIAL_CATEGORY_SELECT' | translate"
            [selectedModel]="materialCategory"
            [autoDetectDeletedSelection]="true"
            (selectedModelDeleted)="materialCategoryIsDeleted = $event"
            (changeEvent)="onMaterialCategoryChange($event)"
            [service]="materialCategoryService"
            class="fxFlex-100p"
          >
          </app-gt2-select>
          <div
            *ngIf="materialCategoryIsDeleted"
            class="red-fg mat-caption fxFlex-100p"
            style="font-style: italic"
          >
            {{ "ORDERS.CATEGORY_DELETED_HINT" | translate }}
          </div>
        </div>
        <!-- supplier name if exist -->
        <div class="item-width">
          <app-gt2-select
            [service]="materialProviderService"
            [nullableUseNone]="false"
            [placeHolder]="'ORDERS.MATERIAL_PROVIDER' | translate"
            [label]="'ORDERS.MATERIAL_PROVIDER' | translate"
            [selectedModel]="material.material_provider"
            [autoDetectDeletedSelection]="true"
            (selectedModelDeleted)="materialProviderIsDeleted = $event"
            (changeEvent)="onMaterialProviderSelected($event)"
            [noResultsLabel]="
              translate.instant('ORDERS.NO_MATERIAL_PROVIDER_RESULTS')
            "
            class="fxFlex-100p"
          ></app-gt2-select>
          <div
            *ngIf="materialProviderIsDeleted"
            class="red-fg mat-caption fxFlex-100p"
            style="font-style: italic"
          >
            {{ "ORDERS.PROVIDER_DELETED_HINT" | translate }}
          </div>
        </div>
      </div>
      <div class="flex-column-start-stretch fxLayoutGap-20 fxFlex-65p">
        <!-- ROW 1: material descriptions FR / EN under tabs -->
        <div class="item-width">
          <mat-tab-group
            animationDuration="100ms"
            mat-stretch-tabs="false"
            mat-align-tabs="start"
            class="description-tabs"
          >
            <mat-tab label="{{ 'ORDERS.PRODUCT_DESCRIPTION_FR' | translate }}">
              <div class="item-width pt-8">
                <p-editor
                  #prodNoteFrEditor
                  formControlName="description_fr_CA"
                  [(ngModel)]="material.description_local.description_fr_CA"
                  [style]="{
                    height: '160px',
                    width: '100%',
                    resize: 'vertical',
                    overflow: 'auto',
                  }"
                >
                  <ng-template pTemplate="header" class="">
                    <span class="ql-formats">
                      <button class="ql-bold"></button>
                      <button class="ql-italic"></button>
                      <button class="ql-underline"></button>
                      <button class="ql-strike"></button>
                    </span>

                    <span class="ql-formats">
                      <select class="ql-color"></select>
                      <select class="ql-background"></select>
                    </span>

                    <span class="ql-formats">
                      <button class="ql-list" value="ordered"></button>
                      <button class="ql-list" value="bullet"></button>
                      <button class="ql-indent" value="-1"></button>
                      <button class="ql-indent" value="+1"></button>
                    </span>

                    <span class="ql-formats">
                      <app-emoji-picker-button
                        [editor]="prodNoteFrEditor"
                      ></app-emoji-picker-button>
                    </span>
                  </ng-template>
                </p-editor>
                <mat-error
                  *ngIf="form.controls.description_fr_CA.invalid"
                  class="p-4 pr-8 flex-row-end-center"
                >
                  {{ "GENERIC.NOTE_EDITOR_LENGTH_INVALID_2048" | translate }}
                </mat-error>
              </div>
            </mat-tab>

            <mat-tab label="{{ 'ORDERS.PRODUCT_DESCRIPTION_EN' | translate }}">
              <div class="item-width pt-8">
                <p-editor
                  #prodNoteEnEditor
                  formControlName="description_en_CA"
                  [(ngModel)]="material.description_local.description_en_CA"
                  [style]="{
                    height: '160px',
                    width: '100%',
                    resize: 'vertical',
                    overflow: 'auto',
                  }"
                >
                  <ng-template pTemplate="header" class="">
                    <span class="ql-formats">
                      <button class="ql-bold"></button>
                      <button class="ql-italic"></button>
                      <button class="ql-underline"></button>
                      <button class="ql-strike"></button>
                    </span>

                    <span class="ql-formats">
                      <select class="ql-color"></select>
                      <select class="ql-background"></select>
                    </span>

                    <span class="ql-formats">
                      <button class="ql-list" value="ordered"></button>
                      <button class="ql-list" value="bullet"></button>
                      <button class="ql-indent" value="-1"></button>
                      <button class="ql-indent" value="+1"></button>
                    </span>

                    <span class="ql-formats">
                      <app-emoji-picker-button
                        [editor]="prodNoteEnEditor"
                      ></app-emoji-picker-button>
                    </span>
                  </ng-template>
                </p-editor>
                <mat-error
                  *ngIf="form.controls.description_en_CA.invalid"
                  class="p-4 pr-8 flex-row-end-center"
                >
                  {{ "GENERIC.NOTE_EDITOR_LENGTH_INVALID_2048" | translate }}
                </mat-error>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>

        <!-- ROW 2: material logistic note -->
        <div class="item-width">
          <div class="title">{{ "ORDERS.NOTE_LOGISTIC" | translate }}</div>
          <p-editor
            #prodNoteLogisticEditor
            formControlName="logistic_notes"
            [(ngModel)]="material.logistic_notes"
            [style]="{
              height: '160px',
              width: '100%',
              resize: 'vertical',
              overflow: 'auto',
            }"
          >
            <ng-template pTemplate="header" class="">
              <span class="ql-formats">
                <button class="ql-bold"></button>
                <button class="ql-italic"></button>
                <button class="ql-underline"></button>
                <button class="ql-strike"></button>
              </span>

              <span class="ql-formats">
                <select class="ql-color"></select>
                <select class="ql-background"></select>
              </span>

              <span class="ql-formats">
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
                <button class="ql-indent" value="-1"></button>
                <button class="ql-indent" value="+1"></button>
              </span>

              <span class="ql-formats">
                <app-emoji-picker-button
                  [editor]="prodNoteLogisticEditor"
                ></app-emoji-picker-button>
              </span>
            </ng-template>
          </p-editor>
          <mat-error
            *ngIf="form.controls.logistic_notes.invalid"
            class="p-4 pr-8 flex-row-end-center"
          >
            {{ "GENERIC.NOTE_EDITOR_LENGTH_INVALID_2048" | translate }}
          </mat-error>
        </div>

        <!-- material sale note sale_note -->
        <div class="item-width">
          <div class="title">
            {{ "ORDERS.NOTE_SALE_MATERIAL" | translate }}
          </div>
          <p-editor
            #prodNoteSaleEditor
            formControlName="sale_note"
            [(ngModel)]="material.sale_note"
            [style]="{
              height: '160px',
              width: '100%',
              resize: 'vertical',
              overflow: 'auto',
            }"
          >
            <ng-template pTemplate="header" class="">
              <span class="ql-formats">
                <button class="ql-bold"></button>
                <button class="ql-italic"></button>
                <button class="ql-underline"></button>
                <button class="ql-strike"></button>
              </span>

              <span class="ql-formats">
                <select class="ql-color"></select>
                <select class="ql-background"></select>
              </span>

              <span class="ql-formats">
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
                <button class="ql-indent" value="-1"></button>
                <button class="ql-indent" value="+1"></button>
              </span>

              <span class="ql-formats">
                <app-emoji-picker-button
                  [editor]="prodNoteSaleEditor"
                ></app-emoji-picker-button>
              </span>
            </ng-template>
          </p-editor>
          <mat-error
            *ngIf="form.controls.sale_note.invalid"
            class="p-4 pr-8 flex-row-end-center"
          >
            {{ "GENERIC.NOTE_EDITOR_LENGTH_INVALID_2048" | translate }}
          </mat-error>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="loading" class="flex-row-center-start">
    <mat-spinner [diameter]="40" class="mt-20"></mat-spinner>
  </div>
  </div>

  <footer
    [formGroup]="form"
    class="panel-footer gt2-buttons-theme flex-row-center-center"
  >
    <button
      mat-raised-button
      color="accent"
      class="mr-16"
      type="submit"
      [disabled]="!form.valid || loading"
      (click)="onSaveMaterial()"
    >
      {{ "GENERIC.SAVE" | translate }}
    </button>

    <button
      mat-raised-button
      color="primary"
      (click)="close()"
    >
      {{ "GENERIC.CANCEL" | translate }}
    </button>
  </footer>
</div>
